/**
 * @generated SignedSource<<c4fb51f639f5e1ee4b966c6c7dfc7133>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type planningSuccess_periscope_AutoDevJobsPlanningSuccess$data = {
  readonly __typename: "WorkSuggestionsAutoDevJobsPlanSuccessTask";
  readonly id: string;
  readonly issue: {
    readonly iconUrl: string | null | undefined;
    readonly id: string;
    readonly key: string;
    readonly summary: string | null | undefined;
    readonly webUrl: string | null | undefined;
  };
  readonly repoUrl: string | null | undefined;
  readonly " $fragmentType": "planningSuccess_periscope_AutoDevJobsPlanningSuccess";
};
export type planningSuccess_periscope_AutoDevJobsPlanningSuccess$key = {
  readonly " $data"?: planningSuccess_periscope_AutoDevJobsPlanningSuccess$data;
  readonly " $fragmentSpreads": FragmentRefs<"planningSuccess_periscope_AutoDevJobsPlanningSuccess">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "planningSuccess_periscope_AutoDevJobsPlanningSuccess",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "concreteType": "WorkSuggestionsAutoDevJobJiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "summary"
        },
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        },
        {
          "kind": "ScalarField",
          "name": "webUrl"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "repoUrl"
    }
  ],
  "type": "WorkSuggestionsAutoDevJobsPlanSuccessTask"
};
})();

(node as any).hash = "753814162dcbfb3b86dc7592d53639f0";

export default node;
